import React, { useState, useEffect, useContext } from "react";
import { Card, Modal } from "antd";
import { Image } from "antd";
import { Tag } from "antd";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { fetchPortfolioAlbums } from "../../services/ApiService";
import { DataContext } from "../../contexts/DataContext";
import { PortfolioAlbum } from "../../models/PortfolioAlbum";

// Local interfaces removed since we use PortfolioAlbum model imported above

const AlbumGallery: React.FC = () => {
  const { state, dispatch } = useContext(DataContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState<PortfolioAlbum | null>(null);

  useEffect(() => {
    if (!state.portfolioAlbums) {
      fetchPortfolioAlbums(dispatch);
    }
  }, [dispatch, state.portfolioAlbums]);

  const openModal = (album: PortfolioAlbum) => {
    setSelectedAlbum(album);
    setModalVisible(true);
  };

  const closeModal = () => {
    setSelectedAlbum(null);
    setModalVisible(false);
  };

  // State to track selected keyword
  const [selectedKeyword, setSelectedKeyword] = useState<string | null>(null);

  // Function to handle keyword selection
  const handleKeywordSelect = (keyword: string) => {
    if (selectedKeyword === keyword) {
      setSelectedKeyword("");
    } else {
      setSelectedKeyword(keyword);
    }
  };

  // Filter albums based on selected keyword.
  const filteredAlbums: PortfolioAlbum[] | undefined = state.portfolioAlbums?.filter((album) => {
    if (!selectedKeyword) return true;
    return album.portfolio_keywords?.some((kw) => kw.Keyword === selectedKeyword);
  });

  const shuffle = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  return (
    <div style={{ marginLeft: "10%", marginRight: "10%", textAlign: "center" }}>
      <div>
        {state.portfolioKeywords?.map((keyword) => (
          <Tag
            key={keyword.Keyword}
            color={selectedKeyword === keyword.Keyword ? "geekblue" : undefined}
            onClick={() => handleKeywordSelect(keyword.Keyword)}
            style={{ cursor: "pointer", marginBottom: "8px" }}
          >
            {keyword.Keyword}
          </Tag>
        ))}
      </div>

      <ResponsiveMasonry
        columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 4, 1500: 5 }}
      >
        <Masonry gutter="20px">
          {filteredAlbums?.map((album) => (
            <Card
              hoverable
              cover={
                <img
                  src={state.baseApiPath + album.KeyImage.url}
                  alt={album.Title}
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              }
              onClick={() => openModal(album)}
              style={{ cursor: "pointer" }}
            >
              <Card.Meta title={album.Title} description={album.Description} />
            </Card>
          ))}
        </Masonry>
      </ResponsiveMasonry>

      <Modal
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        centered
        title={selectedAlbum?.Title}
        width={"90%"}
        style={{ textAlign: "center" }}
        bodyStyle={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}
      >
        {selectedAlbum && (
          <div style={{ textAlign: "center" }}>
            <Image.PreviewGroup
              preview={{
                onChange: (current, prev) =>
                  console.log(`current index: ${current}, prev index: ${prev}`),
              }}
            >
              <ResponsiveMasonry
                columnsCountBreakPoints={{
                  350: 1,
                  750: 2,
                  900: 3,
                  1200: 4,
                  1500: 5,
                }}
              >
                <Masonry gutter="20px">
                  {shuffle(selectedAlbum.Album).map((image, index) => (
                    <div
                      style={{
                        display: "inline-block",
                        borderRadius: 8,
                        overflow: "hidden",
                      }}
                      key={index}
                    >
                      <Image src={state.baseApiPath + image.url} />
                    </div>
                  ))}
                </Masonry>
              </ResponsiveMasonry>
            </Image.PreviewGroup>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AlbumGallery;
